import styled from 'styled-components';
import { setAlpha } from '../../../../styles';
import { Box, HStack } from '../../../Core';
import { Text } from '../../../Text';
import { useIsWorkflowOverviewVisible, type WorkflowOverviewStore } from './workflowOverviewStore';

export function WorkflowHeaderTitle({ title, isOverview = false }: { title: string; isOverview?: boolean }) {
  return (
    <HStack
      gap="spacing12"
      minWidth={0}
      maxWidth="100%"
      flex="1"
      overflow="hidden"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Text data-testid="title-text" fontWeight="500" fontSize="fontSizeDefault" lineHeight="1">
        {title}
      </Text>
      {isOverview ? (
        <OverviewChip data-testid="title-chip">
          <Text
            color="colorTextDefault"
            textTransform="uppercase"
            fontSize="fontSizeTiny"
            fontWeight="500"
            lineHeight="1"
          >
            Overview
          </Text>
        </OverviewChip>
      ) : (
        <Box
          data-testid="title-chip"
          px="spacing10"
          py="spacing6"
          background="backgroundDefaultButton"
          borderRadius="borderRadiusDefault"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minWidth="44px"
        >
          <Text
            color="colors.gray.090"
            textTransform="uppercase"
            fontSize="fontSizeTiny"
            fontWeight="500"
            lineHeight="1"
          >
            NEW
          </Text>
        </Box>
      )}
    </HStack>
  );
}

export function WorkflowHeaderTitleWithOverview({ title, store }: { title: string; store: WorkflowOverviewStore }) {
  const isOverviewVisible = useIsWorkflowOverviewVisible(store);
  return <WorkflowHeaderTitle title={title} isOverview={isOverviewVisible} />;
}

const OverviewChip = styled(Box).attrs({
  px: 'spacing10',
  py: 'spacing6',
  borderRadius: 'borderRadiusDefault',
  display: 'flex',
  alignItems: 'center',
})`
  background: ${({ theme }) => setAlpha(0.16, theme.colors.blue.default)};
`;
